import { zodSchemaForType } from '@bos/utils';
import type { SortingState } from '@tanstack/react-table';
import { z } from 'zod';

import { ClientSearchSortFieldV12 } from '../../api/generated/cz.partners.pid.backofficegateway.pid.external';

export const searchClientSortSchema = zodSchemaForType<SortingState>()(
	z
		.object({
			id: z.string(),
			desc: z.boolean(),
		})
		.array(),
).prefault([
	{
		desc: false,
		id: ClientSearchSortFieldV12.LAST_NAME,
	},
]);
